<template>
    <div class="icon-container">
        <i :class="iconClass"></i>
        <span class="tooltip">{{ text }}</span>
    </div>
</template>

<script>
export default {
    props: {
        iconClass: String,
        text: String
    },
};
</script>

<style scoped>
.icon-container {
    position: relative;
    display: inline-block;
}

.tooltip {
    visibility: hidden;
    background-color: var(--dark);
    color: var(--white);
    text-align: center;
    border-radius: 5px;
    padding: 6px;
    position: absolute;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px;
    white-space: nowrap;
}

/* Tooltip arrow */
.tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
}

.icon-container:hover .tooltip {
    visibility: visible;
    opacity: 1;
}
</style>